{
  "title": "Willkommen",
  "logout": "Abmelden",
  "item_one": "1 Gegenstand",
  "item_few": "{{count}} Gegenstände",
  "item_other": "{{count}} Gegenstände",
  "submit-registration-btn": "GEHEN"
}